gsap.config({
  nullTargetWarn: false,
});
import { gsap } from 'gsap';
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { MotionPathPlugin } from "gsap/MotionPathPlugin";

// 星アニメーション
window.addEventListener("DOMContentLoaded", () => {
  if($('.starsBox').length) {
    const stars = document.querySelector(".starsBox");
    const createStar = () => {
      const starEl = document.createElement("span");
      starEl.className = "ico-star";
      const minSize = 10; // 星の最小サイズを指定
      const maxSize = 20; // 星の最大サイズを指定
      const size = Math.random() * (maxSize - minSize) + minSize;
      starEl.style.width = `${size}px`;
      starEl.style.height = `${size}px`;
      starEl.style.left = `${Math.random() * 100}%`;
      starEl.style.top = `${Math.random() * 100}%`;
      starEl.style.animationDelay = `${Math.random() * 20}s`;
      stars.appendChild(starEl);
    };
    for (let i = 0; i <= 120; i++) {
      createStar();
    }
  }
});

// テキストアニメーション
window.addEventListener('scroll', function(e) {
  var scrollY = window.pageYOffset;
  var windowH = window.innerHeight;
  var showTiming = 200; // 要素を表示するタイミング
  $('.js-textAnime').not('.is_animated').each((index, element) => {
    const elemY = $(element).offset().top;
    if(scrollY > elemY - windowH + showTiming) {
      const brSplitted = $(element).html().split('<br>');
      let mapped = [];
      brSplitted.forEach((item, index) => {
        const itemSplitted = item.split('');
        const brFormatted = itemSplitted.map((item) => {
            return `<span class="data-text-wrap"><span class="data-text-inner">${item}</span></span>`;
        });
        mapped[index] = brFormatted.join('');
      })
      $(element).addClass('is_anime_trigger');
      const result = mapped.join('<br>');
      $(element).html(result);

      const length = $(element).find('.data-text-wrap').length;
      for (let i = 0; i < length; i++) {
        $(element).find('.data-text-inner').eq(i).css(
          'animation', `showTextFromBottom 500ms ${100 * i}ms forwards, showTextOpacity 500ms ${100 * i}ms forwards`
        );
      }
      $(element).addClass('is_animated');
    }
  });
});

$(document).ready(function() {
  $('.js-textAnime02').each(function() {
    const element = $(this);
    const brSplitted = element.html().split('<br>');

    let mapped = [];
    brSplitted.forEach((item, index) => {
      const itemSplitted = item.split('');
      const brFormatted = itemSplitted.map((item)=> {
        // Wrap each character in a span with classes for animation
        return `<span class="data-text-wrap"><span class="data-text-inner">${item.replace(/\s/g, '&nbsp;')}</span></span>`;
      });
      mapped[index] = brFormatted.join('');
    });

    element.addClass('is_anime_trigger');
    const result = mapped.join('<br>');
    element.html(result);

    const length = element.find('.data-text-wrap').length;
    for (let i = 0; i < length; i++) {
      element.find('.data-text-inner').eq(i).css(
        'animation',`showTextFromBottom 500ms ${100 * i}ms forwards, showTextOpacity 500ms ${100 * i}ms forwards`
      );
    }
    element.addClass('is_animated');
  });
});

gsap.registerPlugin(ScrollTrigger, MotionPathPlugin);
gsap.registerPlugin(ScrollTrigger, MotionPathPlugin);

var icoTriangle = $('.ico-triangle.topAnime');
gsap.set(icoTriangle, {
  opacity: 0,
  x: '-100%',
  y: 0,
});

var icoTriangle = $('.ico-triangle.topAnime');
gsap.set(icoTriangle, {
  opacity: 0,
  x: '-100%',
  y: 0,
});

// var topBg = $('.top-bg');
// gsap.set(topBg, {
//   opacity: 0,
//   x: '100%',
//   y: 0,
// });

var topMvLine01 = $('.topMv-line01 .cls-1');
var topMvLine02 = $('.topMv-line02 .cls-1');
var topAboutLine03 = $('.topAbout-line03 .cls-1');
var topRecruitLine04 = $('.topRecruit-line04 .cls-1');
var topNewsLine05 = $('.topNews-line05 .cls-1');
var topNoteLine05 = $('.topNote-line06 .cls-1');

var topBox0 = $('.topMv-box0');
gsap.set(topBox0, {
  opacity: 0,
});

var topBox = $('.topMv-box');
gsap.set(topBox, {
  opacity: 0,
  y: 50,
});

var topMvSlider = $('.topMv-slider');
gsap.set(topMvSlider, {
  opacity: 0,
  y: '100px',
});

window.addEventListener("load", function () {

  // const tl_topBg = gsap.timeline();
  // tl_topBg.to(topBg, {
  //   opacity: 1,
  //   x: '0%',
  //   y: 0,
  //   duration: 1,
  //   ease: "power1",
  // })

    // var topBox0Lead = $('.topMv-box0__lead');
  // const tl_topBox0Lead = gsap.timeline();
  // tl_topBox0Lead.to(topBox0Lead, {
  //   opacity: 1,
  //   y: 0,
  //   duration: 1,
  //   ease: "power1",
  //   onComplete: function() {
  //     if(!topBox0Lead.hasClass('is_animated')) {
  //       const brSplitted = topBox0Lead.html().split('<br>');
  //       let mapped = [];
  //       brSplitted.forEach((item, index) => {
  //         const itemSplitted = item.split('');
  //         const brFormatted = itemSplitted.map((item) => {
  //             return `<span class="data-text-wrap03"><span class="data-text-inner03">${item}</span></span>`;
  //         });
  //         mapped[index] = brFormatted.join('');
  //       })
  //       topBox0Lead.addClass('is_anime_trigger');
  //       const result = mapped.join('<br>');
  //       topBox0Lead.html(result);

  //       const length = $('.topMv-box0__lead').find('.data-text-wrap03').length;
  //       for (let i = 0; i < length; i++) {
  //         topBox0Lead.find('.data-text-inner03').eq(i).css(
  //           'animation', `showTextFromBottom02 1000ms ${10 * i}ms forwards, showTextOpacity02 100ms ${10 * i}ms forwards`
  //         );
  //       }
  //       topBox0Lead.addClass('is_animated');
  //     }
  //   }
  // }, "0");

  const tl_topBox0 = gsap.timeline();
  tl_topBox0.to(topBox0, {
    opacity: 1,
    y: 0,
    duration: 1,
    ease: "power1",
  }, "0");

  const tl_topBox0Lead = gsap.timeline();
  $('.topMv-box0__lead').each(function() {
    const topBox0Lead = $(this);
    tl_topBox0Lead.to(topBox0Lead, {
      opacity: 1,
      y: 0,
      duration: 1,
      ease: "power1",
      onComplete: function() {
        if(!topBox0Lead.hasClass('is_animated')) {
          const brSplitted = topBox0Lead.html().split('<br>');
          let mapped = [];
          brSplitted.forEach((item, index) => {
            const itemSplitted = item.split('');
            const brFormatted = itemSplitted.map((item) => {
                return `<span class="data-text-wrap03"><span class="data-text-inner03">${item}</span></span>`;
            });
            mapped[index] = brFormatted.join('');
          })
          topBox0Lead.addClass('is_anime_trigger');
          const result = mapped.join('<br>');
          topBox0Lead.html(result);
  
          const length = $('.topMv-box0__lead').find('.data-text-wrap03').length;
          for (let i = 0; i < length; i++) {
            topBox0Lead.find('.data-text-inner03').eq(i).css(
              'animation', `showTextFromBottom02 2000ms ${30 * i}ms forwards, showTextOpacity02 300ms ${30 * i}ms forwards`
            );
          }
          topBox0Lead.addClass('is_animated');
        }
      }
    },"0");
  });

  const tl_topBox0Disable = gsap.timeline();
  tl_topBox0Disable.to(topBox0, {
    opacity: 0,
    y: 0,
    duration: .5,
    ease: "power1",
  }, "+=4");

  const tl_topMvLine01 = gsap.timeline();
  tl_topMvLine01.to(topMvLine01, {
    strokeDashoffset: 0,
    duration: 1,
    ease: "power1",
  },"+=0.5");

  const tl_topMvSlider = gsap.timeline();
  tl_topMvSlider.to(topMvSlider, {
    opacity: 1,
    y: 0,
    duration: 1,
    ease: "power1",
  },"+=1");

  const tl_topMvLine02 = gsap.timeline();
  tl_topMvLine02.to(topMvLine02, {
    strokeDashoffset: 0,
    duration: 1,
    ease: "power1",
  },"0");

  const tl_icoTriangle = gsap.timeline();
  tl_icoTriangle.to(icoTriangle, {
    opacity: 1,
    x: '0%',
    y: 0,
    duration: 1,
    ease: "power1",
  },"+=0.5");

  var topBoxTtl = $('.topMv-box__ttl');
  const tl_topBox = gsap.timeline();
  tl_topBox.to(topBox, {
    opacity: 1,
    y: 0,
    duration: 1,
    ease: "power1",
    after: function() {
      if(!topBoxTtl.hasClass('is_animated')) {
        const brSplitted = topBoxTtl.html().split('<br>');
        let mapped = [];
        brSplitted.forEach((item, index) => {
          const itemSplitted = item.split('');
          const brFormatted = itemSplitted.map((item) => {
              return `<span class="data-text-wrap"><span class="data-text-inner">${item}</span></span>`;
          });
          mapped[index] = brFormatted.join('');
        })
        topBoxTtl.addClass('is_anime_trigger');
        const result = mapped.join('<br>');
        topBoxTtl.html(result);

        const length = $('.topMv-box__ttl').find('.data-text-wrap').length;
        for (let i = 0; i < length; i++) {
          topBoxTtl.find('.data-text-inner').eq(i).css(
            'animation', `showTextFromBottom 500ms ${100 * i}ms forwards, showTextOpacity 500ms ${100 * i}ms forwards`
          );
        }
        topBoxTtl.addClass('is_animated');
      }
    }
  },"+=0.5");


  var topMv1 = $('.topMv-slider__item.item01');
  if(topMv1.length) {
    var topMvCenter = offsetCenter(topMv1);
  }
  var topMv2 = $('.topMv-slider__item.item02');
  if(topMv2.length) {
    var topMvCenter2 = offsetCenter(topMv2);
  }
  var topMv3 = $('.topMv-slider__item.item03');
  if(topMv3.length) {
    var topMvCenter3 = offsetCenter(topMv3);
  }

  // 中心点プロット(デバッグ用)
  // addCenterPoint1(topMvCenter);
  // addCenterPoint2(topMvCenter2);
  // addCenterPoint3(topMvCenter3);

  // 移動量算出
  if(topMv1.length && topMv2.length && topMv3.length) {
    var route12_x = topMvCenter2.left - topMvCenter.left;
    var route12_y = topMvCenter2.top - topMvCenter.top;
    console.log('route12_x, route12_y', route12_x, route12_y);

    var route23_x = topMvCenter3.left - topMvCenter2.left;
    var route23_y = topMvCenter3.top - topMvCenter2.top;
    console.log('route23_x, route23_y', route23_x, route23_y);

    var route31_x = topMvCenter.left - topMvCenter3.left;
    var route31_y = topMvCenter.top - topMvCenter3.top;
    console.log('route31_x, route31_y', route31_x, route31_y);
  }

  const tl_slideMv = gsap.timeline({ repeat: -1 }); // 無限ループ

  tl_slideMv.to(topMv1, { // 1が消える
    x: -route12_x,
    y: -route12_y,
    autoAlpha: 0,
    duration: 1,
    zIndex: -1,
    ease: "power4",
  }, "+=1.5")
  .to(topMv2, { // 2が先頭に移動
    x: -route12_x,
    y: -route12_y,
    zIndex: 3,
    duration: .7,
    ease: "power4",
  })
  .to(topMv3, { // 3が真ん中に移動
    x: -route23_x,
    y: -route23_y,
    zIndex: 2,
    duration: .7,
    ease: "power4",
  }, "-=0.3")
  .set(topMv1, { // 1を後ろにセット
    x: -route31_x + route12_x,
    y: -route31_y + route12_y,
    autoAlpha: 0,
  }, "-=0.3")
  .to(topMv1, { // 1が移動しながら現れる
    x: -route31_x,
    y: -route31_y,
    autoAlpha: 1,
    zIndex: 1,
    duration: .7,
    ease: "power4",
  }, "-=0.3")
  .to(topMv2, { // 2が消える
    x: -route12_x*2,
    y: -route12_y*2,
    autoAlpha: 0,
    duration: 1,
    zIndex: -1,
    ease: "power4",
  })
  .to(topMv3, { // 3が先頭に移動
    x: -route23_x*2,
    y: -route23_y*2,
    zIndex: 3,
    duration: .7,
    ease: "power4",
  })
  .to(topMv1, { // 1が真ん中に移動
    x: route12_x,
    y: route12_y,
    zIndex: 2,
    duration: .7,
    ease: "power4",
  }, "-=0.3")
  .set(topMv2, { // 2を後ろにセット
    x: -route31_x,
    y: -route31_y,
    autoAlpha: 0,
  }, "-=0.3")
  .to(topMv2, { // 2が移動しながら現れる
    x: route12_x,
    y: route12_y,
    autoAlpha: 1,
    zIndex: 1,
    duration: .7,
    ease: "power4",
  }, "-=0.3")
  .to(topMv3, { // 3が消える
    x: -route23_x*3,
    y: -route23_y*3,
    autoAlpha: 0,
    duration: 1,
    zIndex: -1,
    ease: "power4",
  })
  .to(topMv1, { // 1が先頭に移動
    x: 0,
    y: 0,
    zIndex: 3,
    duration: .7,
    ease: "power4",
  })
  .to(topMv2, { // 2が真ん中に移動
    x: 0,
    y: 0,
    zIndex: 2,
    duration: .7,
    ease: "power4",
  }, "-=0.3")
  .set(topMv3, { // 3を後ろにセット
    x: route12_x,
    y: route12_y,
    autoAlpha: 0,
  }, "-=0.3")
  .to(topMv3, { // 3が移動しながら現れる
    x: 0,
    y: 0,
    autoAlpha: 1,
    zIndex: 1,
    duration: .7,
    ease: "power4",
  }, "-=0.3")

  // 以下を順番に実行
  const mainTimeline = gsap.timeline();
  mainTimeline
  .add(tl_topBox0)
  .add(tl_topBox0Lead)
  .add(tl_topBox0Disable)
  .add(tl_topMvLine01)
  .add(tl_topMvSlider)
  .add(tl_topMvLine02)
  .add(tl_icoTriangle)
  .add(tl_topBox)
  .add(topBoxTtl);

  gsap.to(topAboutLine03, {
    strokeDashoffset: 0,
    duration: 2,
    ease: "power1",
    scrollTrigger: {
      trigger: '.topAbout', // トリガーとなる要素（アニメーションの開始、終了の位置決定に使用する）
      start: 'top center+=20%', // アニメーションの開始位置の指定
      // markers: true,
    }
  });

  gsap.to(topRecruitLine04, {
    strokeDashoffset: '5605.77001953125px',
    duration: 2,
    ease: "power1",
    scrollTrigger: {
      trigger: '.topRecruit', // トリガーとなる要素（アニメーションの開始、終了の位置決定に使用する）
      start: 'top center+=20%', // アニメーションの開始位置の指定
      // markers: true,
    }
  });

  gsap.to(topNewsLine05, {
    strokeDashoffset: '2262.644775390625px',
    duration: 2,
    ease: "power1",
    scrollTrigger: {
      trigger: '.topNews', // トリガーとなる要素（アニメーションの開始、終了の位置決定に使用する）
      start: 'top center+=20%', // アニメーションの開始位置の指定
      // markers: true,
    }
  });

  gsap.to(topNoteLine05, {
    strokeDashoffset: '917.7138671875px',
    duration: 2,
    ease: "power1",
    scrollTrigger: {
      trigger: '.topNote', // トリガーとなる要素（アニメーションの開始、終了の位置決定に使用する）
      start: 'top center+=20%', // アニメーションの開始位置の指定
      // markers: true,
    }
  });

    gsap.to(cmnLine01, {
    strokeDashoffset: '917.7138671875px',
    duration: 2,
    ease: "power1",
    scrollTrigger: {
      trigger: '.topNote', // トリガーとなる要素（アニメーションの開始、終了の位置決定に使用する）
      start: 'top center+=20%', // アニメーションの開始位置の指定
      // markers: true,
    }
  });

});

document.querySelectorAll(".cmn-line03").forEach((el, index) => {
  ScrollTrigger.create({
      trigger: el,
      id: index+1,
      start: 'top center',
      toggleClass: {targets: el, className: "is-lineOn"},
      once: true,
      // markers: true,
  });
});

document.querySelectorAll(".cmn-line04").forEach((el, index) => {
  ScrollTrigger.create({
      trigger: el,
      id: index+1,
      start: 'top center',
      toggleClass: {targets: el, className: "is-lineOn"},
      once: true,
      // markers: true,
  });
});

document.querySelectorAll(".cmn-line05").forEach((el, index) => {
  ScrollTrigger.create({
      trigger: el,
      id: index+1,
      start: 'top center',
      toggleClass: {targets: el, className: "is-lineOn"},
      once: true,
      // markers: true,
  });
});

document.querySelectorAll(".cmn-line07").forEach((el, index) => {
  ScrollTrigger.create({
      trigger: el,
      id: index+1,
      start: 'top center',
      toggleClass: {targets: el, className: "is-lineOn"},
      once: true,
      // markers: true,
  });
});

document.querySelectorAll(".cmn-rp-line01").forEach((el, index) => {
  ScrollTrigger.create({
      trigger: el,
      id: index+1,
      start: 'top center',
      toggleClass: {targets: el, className: "is-lineOn"},
      once: true,
      // markers: true,
  });
});

document.querySelectorAll(".cmn-rb-line02").forEach((el, index) => {
  ScrollTrigger.create({
      trigger: el,
      id: index+1,
      start: 'top center',
      toggleClass: {targets: el, className: "is-lineOn"},
      once: true,
      // markers: true,
  });
});

document.querySelectorAll(".cmn-rp-line02").forEach((el, index) => {
  ScrollTrigger.create({
      trigger: el,
      id: index+1,
      start: 'top center',
      toggleClass: {targets: el, className: "is-lineOn"},
      once: true,
      // markers: true,
  });
});

document.querySelectorAll(".cmn-rb-line03").forEach((el, index) => {
  ScrollTrigger.create({
      trigger: el,
      id: index+1,
      start: 'top center',
      toggleClass: {targets: el, className: "is-lineOn"},
      once: true,
      // markers: true,
  });
});

ScrollTrigger.create({
  trigger: ".js-cvTrigger",
  start: "top center",
  // endTrigger: '.cmn-entrySec',
  // end: "top bottom",
  // markers: true,
  toggleClass: {
    targets: '.cmn-inner.js-cvTrigger',
    className: 'is-cvOn',
  },
  // once: true,
});

ScrollTrigger.create({
  trigger: ".js-cvTrigger",
  start: "top center",
  endTrigger: '.cmn-entrySec',
  end: "top bottom",
  // markers: true,
  toggleClass: {
    targets: '.recruitCvBt',
    className: 'is-cvOn',
  },
  // once: true,
});

function offsetCenter(el){
  var left = el.offset().left;
  var top = el.offset().top;
  var width = el.width();
  var height = el.height();
  left = left + (width / 2);
  top = top + (height / 2);
  return { top, left }
}

// 中心点に点を追加
const addCenterPoint1 = (center) => {
  const point = document.createElement('div');
  point.style.position = 'absolute';
  point.style.width = '10px';
  point.style.height = '10px';
  point.style.backgroundColor = 'red';
  point.style.borderRadius = '50%';
  point.style.left = `${center.left}px`;
  point.style.top = `${center.top}px`;
  point.style.zIndex = 100;
  document.body.appendChild(point);
  console.log('topMvCenter', center.left, center.top);
};
const addCenterPoint2 = (center) => {
  const point = document.createElement('div');
  point.style.position = 'absolute';
  point.style.width = '10px';
  point.style.height = '10px';
  point.style.backgroundColor = 'blue';
  point.style.borderRadius = '50%';
  point.style.left = `${center.left}px`;
  point.style.top = `${center.top}px`;
  point.style.zIndex = 100;
  document.body.appendChild(point);
  console.log('topMvCenter2', center.left, center.top);
};
const addCenterPoint3 = (center) => {
  const point = document.createElement('div');
  point.style.position = 'absolute';
  point.style.width = '10px';
  point.style.height = '10px';
  point.style.backgroundColor = 'green';
  point.style.borderRadius = '50%';
  point.style.left = `${center.left}px`;
  point.style.top = `${center.top}px`;
  point.style.zIndex = 100;
  document.body.appendChild(point);
  console.log('topMvCenter3', center.left, center.top);
};
